<template>
	<v-card>
			<v-card-title class="title primary--text secondary" v-translate>Ryodoraku Test</v-card-title>
			<v-card-text class="pa-0">
				<v-form ref="form" v-model="valid">
					<v-row no-gutters>
						<v-carousel :continuous="false">
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>LU</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.p_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.p_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/1.PU.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>PC</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.pc_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.pc_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/2.PC.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>HE</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.c_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.c_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/3.C.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>SI</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.id_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.id_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/4.ID.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>SJ</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.sj_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.sj_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/5.SJ.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>LI</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.ig_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.ig_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/7.IG-2.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>SP</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.bp_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.bp_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/8.BP.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>LIV</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.f_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.f_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/9.F.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>KD</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.r_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.r_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/10.R.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>BL</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.bx_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.bx_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/12.BX.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>GB</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.vb_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.vb_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/11.VB.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
							<v-carousel-item>
								<v-sheet color="primary" height="100%" tile>
									<v-row class="fill-height" justify="center" no-gutters>
										<v-row no-gutters class="mt-4">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<div class="text-h2" v-translate>ST</div>
											</v-col>
											<v-col cols="12" md="4" offset-md="2">
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="leftLabel"
														v-model="test.e_l"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
												<v-row no-gutters>
													<v-text-field
														type="number"
														:rules="integerRules"
														:label="rightLabel"
														v-model="test.e_r"
														required
														outlined
														class="pr-5"
														color=“secondary”
													></v-text-field>
												</v-row>
											</v-col>
											<v-col cols="12" md="4">
												<v-img
													src="../../../../assets/images/13.E.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="400"
													max-height="300"
												></v-img>
											</v-col>
										</v-row>
									</v-row>
								</v-sheet>
							</v-carousel-item>
						</v-carousel>
					</v-row>
				</v-form>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-btn color="primary darken-1" text @click="hide">
					<translate>Cancel</translate>
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn v-if="!edit" color="primary darken-1" text @click="submitTest" :disabled="formComplete">
					<translate>Create</translate>
				</v-btn>
				<v-btn v-else color="primary darken-1" text @click="editTest" :disabled="formComplete">
					<translate>Save</translate>
				</v-btn>
			</v-card-actions>
	</v-card>
</template>

<script>
export default {
	name: "RyodorakuForm",
	props: {
		test: {
			default: () => ({
				kind: "exam",
				module: "ryodoraku",
				p_l: "",
				p_r: "",
				pc_l: "",
				pc_r: "",
				c_l: "",
				c_r: "",
				id_l: "",
				id_r: "",
				sj_l: "",
				sj_r: "",
				ig_l: "",
				ig_r: "",
				bp_l: "",
				bp_r: "",
				f_l: "",
				f_r: "",
				r_l: "",
				r_r: "",
				bx_l: "",
				bx_r: "",
				vb_l: "",
				vb_r: "",
				e_l: "",
				e_r: ""
			})
		},
		edit: {
			default: false
		}
	},
	data: () => ({
		valid: false,
		integerRules: [
			v => !!v || "Value is required",
			v =>
				(!isNaN(v) && parseInt(Number(v)) == v && !isNaN(parseInt(v, 10))) ||
				"Value invalid"
		]
	}),
	methods: {
		validate() {
			console.log(this.test);
			return this.$refs.form.validate();
		},
		submitTest() {
			if (this.validate()) {
				const form = this.getForm();
				this.$emit("create-test", form);
				this.hide();
			} else {
				console.log("Form Invalid");
			}
		},
		editTest() {
			if (this.validate()) {
				const form = this.getForm();
				this.$emit("edit-test", form);
				this.hide();
			} else {
				console.log("Form Invalid");
			}
		},
		isInt: function(value) {
			return (
				!isNaN(value) &&
				parseInt(Number(value)) == value &&
				!isNaN(parseInt(value, 10))
			);
		},
		hide() {
			this.$emit("hide");
		},
		getForm() {
			const formData = new FormData();
			formData.append("p_l", this.test.p_l);
			formData.append("p_r", this.test.p_r);
			formData.append("pc_l", this.test.pc_l);
			formData.append("pc_r", this.test.pc_r);
			formData.append("c_l", this.test.c_l);
			formData.append("c_r", this.test.c_r);
			formData.append("id_l", this.test.id_l);
			formData.append("id_r", this.test.id_r);
			formData.append("sj_l", this.test.sj_l);
			formData.append("sj_r", this.test.sj_r);
			formData.append("ig_l", this.test.ig_l);
			formData.append("ig_r", this.test.ig_r);
			formData.append("bp_l", this.test.bp_l);
			formData.append("bp_r", this.test.bp_r);
			formData.append("f_l", this.test.f_l);
			formData.append("f_r", this.test.f_r);
			formData.append("r_l", this.test.r_l);
			formData.append("r_r", this.test.r_r);
			formData.append("bx_l", this.test.bx_l);
			formData.append("bx_r", this.test.bx_r);
			formData.append("vb_l", this.test.vb_l);
			formData.append("vb_r", this.test.vb_r);
			formData.append("e_l", this.test.e_l);
			formData.append("e_r", this.test.e_r);
			formData.append("kind", "exam");
			formData.append("module", "ryodoraku");
			return formData;
		}
	},
	computed: {
		leftLabel() {
			return this.$gettext("Left");
		},
		rightLabel() {
			return this.$gettext("Right");
		},
		formComplete() {
			var disabled = false;
			for (var field in this.test) {
				if (Object.prototype.hasOwnProperty.call(this.test, field)) {
					if (!this.test[field]) {
						disabled = true;
						console.log("gg");
						break;
					}
				}
			}
			return disabled;
		}
	}
};
</script>